export function findCheapestRate(hotelRooms) {
    if (!hotelRooms.length) return null
    const _allRates = hotelRooms.map((room) => room.rates).flat()
    return _allRates.reduce((minRate, rate) => {
        return +rate.total_price.converted.amount < +minRate.total_price.converted.amount ? rate : minRate
    }, { total_price: { converted: { amount: Number.MAX_VALUE } } })
}

export function debounce(func, timeout) {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, timeout);
    };
}

export function throttle(callback, delay) {
    let timeoutHandler = null;
    return function () {
        if (timeoutHandler == null) {
            timeoutHandler = setTimeout(function () {
                callback();
                timeoutHandler = null;
            }, delay);
        }
    }
}

export function scrollToElement(selector, yOffset = 0) {
    if (!selector) {
        return
    }
    const el = typeof selector === 'string' ? document.querySelector(selector) : selector;
    // querySelector returns null when the target has not rendered yet, and reading
    // getBoundingClientRect off null throws. Every existing caller ran after a user action, by
    // which point the node existed; the package preload runs on mount, where it may not.
    if (!el) {
        return
    }
    const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({top: y, behavior: 'smooth'});
}
